'use client';

import { SiteHeader } from '@/components/layout/site-header';
import { SiteFooter } from '@/components/layout/footer';

export default function ThankYouPage() {
  return (
    <div className="min-h-screen bg-paper text-ink flex flex-col">
      <SiteHeader variant="solid" />

      <main className="flex-grow flex items-center justify-center px-fluid-x py-24 md:py-32 lg:py-40">
        <div className="w-full max-w-xl mx-auto">
          <div className="bg-glass-soft border border-[color:color-mix(in_srgb,var(--color-ink)_18%,transparent)] rounded-2xl p-10 md:p-12 shadow-lg text-center">
            <div className="mx-auto w-20 h-20 rounded-full bg-accent/10 border border-accent grid place-items-center mb-6">
              <svg
                className="w-8 h-8"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden
              >
                <path
                  d="M20 6L9 17l-5-5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h1 className="text-2xl md:text-3xl font-semibold leading-tight mb-3">
              Obrigado. Mensagem enviada.
            </h1>

            <p className="text-sm text-ink-64 mb-4 max-w-prose mx-auto">
              Recebemos sua solicitação. Vamos analisar e voltar com um retorno
              dentro de um dia útil.
            </p>

            <p className="mt-6 text-xs text-muted">
              Se precisar alterar algo responda o e-mail de confirmação mantendo
              o assunto.
            </p>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
